<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['CÓDIGO', 'NOME']"
            :showNew="false"
            :showSearch="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Search="onShowSearch"
            v-on:Load="onLoad"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.id" />
        <TableColumn :IsText="true" v-on:Edit="onEdit(obj)" :status="obj.inative ? 0 : 1" :value="obj.nome ? obj.nome.toUpperCase() : ''" />
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <!-- <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'"><i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Novo</span></button> -->
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
// eslint-disable-next-line
import { loading, toast } from '@/shared/utils/UIHelper'

import PositionRepository from '@/shared/http/repositories/configurations/position.js'
import PositionSearchScreen from '../search/search.vue'

export default {
  name: 'PaList',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAll()
      this.$eventHub.on('Filter', ({ filters }) => {
        this.filters = filters
        this.$refs.tableGrid.Clear()
        this.$nextTick(() => {
          this.onLoadAll()
        })
      })
    },
    onLoadAll () {
      loading.close()
      if (this.filters) {
        PositionRepository.Search(this.filters.nome, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      } else {
        PositionRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(this.onResultGrid)
          .catch(this.onException)
      }
    },

    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      // this.$emit('Edit', obj)
    },
    onDelete (obj) {
      // loading.push()
      // PositionRepository.Delete(obj.id)
      //   .then((response) => {
      //     loading.pop()
      //     toast.success(this.$lang.Common.Alerts.Success)
      //     this.onLoadAll()
      //   })
      //   .catch(this.onException)
    },
    onShowSearch () {
      let aside = {
        title: 'Pesquisar',
        self: this,
        component: PositionSearchScreen
      }
      this.$eventHub.emit('Search', aside)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/position/components/list/positionList.vue